"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NullCheckLocalComponentParameters = void 0;
exports.NullCheckLocalComponentParameters = [
    // @ts-expect-error required should be true since it is used by frontend
    {
        id: 'target',
        label: 'Target Variable',
        description: 'Input Param - Location which is to be tested for null value',
        type: 'fixed',
        value: 'null',
        paramType: 'ANY',
        required: true,
    },
    {
        id: 'is_null',
        label: 'Null Test Result',
        description: 'Output Param - Weather the value stored in target is NULL or NOT',
        type: 'output',
        paramType: 'BOOLEAN',
        required: true,
    },
];
//# sourceMappingURL=NullCheckLocal.js.map